import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
// Предполагается, что Container не используется
import { getTgLink } from '../../utils/telegram';

const directions = [
  'Хип-хоп', 'Брейк-данс', 'Contemporary', 'K-Pop',
  'Хип-хоп профи', 'Брейк-данс профи', 'Афро', 'Джаз-фанк'
];

/**
 * Обработчик клика по направлению. Сначала скроллит к секции Programs, 
 * затем вызывает глобальную функцию прокрутки карусели.
 * @param title Название направления.
 */
const handleDirectionClick = (title: string) => {
  const programsSection = document.getElementById('programs');

  if (programsSection) {
    // 1. Скроллим до начала секции programs
    programsSection.scrollIntoView({ behavior: 'smooth' });

    // 2. Вызываем глобально доступную функцию для прокрутки карусели в Programs
    // @ts-ignore
    if (window.scrollToProgramByTitle && typeof window.scrollToProgramByTitle === 'function') {
      // Небольшая задержка, чтобы скролл успел произойти
      // @ts-ignore
      setTimeout(() => window.scrollToProgramByTitle(title), 500); 
    } else {
      console.warn('scrollToProgramByTitle is not defined globally. Cannot scroll to specific program card.');
    }
  } else {
    console.warn('Programs section not found. Cannot scroll.');
  }
};

const Footer: React.FC = () => (
  <footer id="contacts" className="bg-brand-secondary pt-16 lg:pt-24 pb-16 lg:pb-16">
    <div className="grid-system">
      {/* Основной контент футера */}
      <div className="grid-content">
        {/* Изменено: на md - 1 колонка, на lg - 8 колонок. */}
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-8 gap-8 lg:gap-12">
          
          {/* Бренд и описание */}
          {/* md:col-span-full занимает всю ширину на md (768px), как на мобильном */}
          <div className="md:col-span-full lg:col-span-4">
            <div className="flex items-center gap-2.5 z-50 mb-6">
              <span className={`text-brand-white text-2xl md:text-3xl font-bold tracking-tight display-md`}>
                Fun Dance
              </span>
            </div>
            <p className="body-base md:body-lg text-brand-white/50 max-w-md leading-relaxed">
              Пространство движения, где каждый находит свой стиль. Приходи за энергией и новыми друзьями
            </p>
          </div>

          {/* Контакты */}
          <div className="md:col-span-full lg:col-span-2">
            <h4 className="text-brand-white text-2xl md:text-3xl font-bold tracking-tight display-md mb-6">Контакты</h4>
            <ul className="text-brand-white body-base space-y-2">
              <li className="text-brand-white/50 flex items-center gap-3">
                <MapPin className="shrink-0 text-brand-primary" size={18}/>
                <span className="leading-relaxed">ул. Тюленина, 5</span>
              </li>
              <li className="text-brand-white/50 flex items-center gap-3">
                <Phone className="shrink-0 text-brand-primary" size={18}/>
                +7 (908) 310-65-95
              </li>
              <li className="text-brand-white/50 flex items-center gap-3">
                <Clock className="shrink-0 text-brand-primary" size={18} />
                <span>Пн-Вс: 10:00-22:00</span>
              </li>
            </ul>
          </div>

          {/* Направления */}
          <div className="md:col-span-full lg:col-span-2">
            <h4 className="text-brand-white text-2xl md:text-3xl font-bold tracking-tight display-md mb-6">Направления</h4>
            <div className="grid grid-cols-1 space-y-2 text-brand-white body-base">
              {directions.map((direction) => (
                <button
                  key={direction}
                  className="text-brand-white/50 text-left hover:text-brand-primary transition-colors duration-200"
                  onClick={() => handleDirectionClick(direction)} // Изменено
                >
                  {direction}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;